<template>
    <div style="visibility: hidden;">
        <audio id="gtyQaVoiceNotify" src="https://awp-assets.meituan.net/hfe/fep/gtynotice.mp3"></audio>
        <audio id="jiujingQaVoiceNotify" src="https://awp-assets.meituan.net/hfe/fep/jingjiunotice.mp3"></audio>
        <!-- <audio id="ticketQaVoiceNotify" src=""></audio> -->
    </div>
</template>
<script>
    import AppService from "utils/AppService.js"
    export default {
        data: {
            audioElemMap: {
                ticketQaVoiceNotify: {
                    audioElem: null, // dom元素
                    next: null // 指向下一个
                },
                jiujingQaVoiceNotify: {
                    audioElem: null,
                    next: null
                },
                gtyQaVoiceNotify: {
                    audioElem: null,
                    next: null
                }
            },
            queue: [],
            appService: {}
        },
        beforeCreate() {
            this.appService = new AppService()
        },
        computed: {
            unreadMap () {
                return this.$store.state.unreadMap
            }
        },
        watch: {
            unreadMap: function () {
                if (this.getQAnoticeUnhandled(this.$store.state.unreadMap)) {
                    this.playNotice();
                }
            }
        },
        methods: {
            getQAnoticeUnhandled: function (changesMap) {
                let msgCountRecord;
                try {
                    msgCountRecord = JSON.parse(this.appService.getSerialized(
                        'sessionStorage',
                        'msgCountRecord'
                    )
                    );
                } catch (e) {
                    msgCountRecord = null;
                }

                // 如果sessionStorage中没有消息数目记录
                if (!msgCountRecord) {
                    msgCountRecord = {
                        ticketQaVoiceNotify: 0,
                        jiujingQaVoiceNotify: 0,
                        gtyQaVoiceNotify: 0
                    };
                    this.appService.setSerialized(
                        'sessionStorage',
                        'msgCountRecord',
                        JSON.stringify(msgCountRecord)
                    );
                }

                let filterResArr = Object.keys(changesMap).filter(filterItem => {
                    // msgCountRecord[filterItem]为undefined时永远为false，故无须判断msgCountRecord[filterItem]
                    if (msgCountRecord[filterItem] < changesMap[filterItem]) { // 如果未处理消息数量有新增
                        msgCountRecord[filterItem] = changesMap[filterItem];
                        return true;
                    }
                    // 如果没有新增
                    if (msgCountRecord[filterItem]) {
                        msgCountRecord[filterItem] = changesMap[filterItem] || 0;
                    }
                    return false;
                });

                this.appService.setSerialized(
                    'sessionStorage',
                    'msgCountRecord',
                    JSON.stringify(msgCountRecord)
                );

                this.queue = [...filterResArr];

                return this.queue.length > 0;
            },
            playNotice: function () {
                let queue = this.queue;
                let index = queue.length - 1;
                let lastOfQueue;

                while (index > 0) {
                    lastOfQueue = queue[index--];
                    this.audioElemMap[lastOfQueue].next = queue[index];
                }

                this._playAudioInQueue();
            },
            _playAudioInQueue: function () {
                let queue = _queue || this.queue;
                let lastOfQueue = queue.pop();
                // 代表一个voiceNotify节点(这些抽象的节点包含了消息数目、下一个节点2种信息，类似一个链表)
                let voiceNode = this.audioElemMap[lastOfQueue];

                if (!voiceNode.audioElem) {
                    voiceNode.audioElem = document.querySelector(`#${lastOfQueue}`);
                }

                voiceNode.audioElem.play();

                voiceNode.audioElem.addEventListener('ended', () => {
                    if (queue.length > 0) {
                        this._playAudioInQueue(queue);
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// voiceNotification.vue?67dfffca